export const extractAttitudeBrandData = (
  data: Attitude.LineChartDataItem[],
  mainBrandId: string,
) =>
  data.map(({ date, values }) => ({
    date,
    values: values[mainBrandId] || {},
  }));
